export function combine() {
  var composables = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    composables[_i] = arguments[_i];
  }

  var callbacks = [];
  composables.forEach(function (composable) {
    if (Array.isArray(composable)) {
      callbacks.push.apply(callbacks, composable);
    } else {
      callbacks.push(composable);
    }
  });
  return callbacks;
}
export default combine;